export default "__VITE_ASSET__B7p0C6dk__"